import type { IconName } from "@similarweb/icons";
import { AutoCompleteKeywordGroupsSingleTab } from "pro-features/components/AutocompleteKeywords/AutoCompleteKeywordGroupsSingleTab";
import { translate } from "app/filters/i18nFilter";
import type { FC } from "react";
import { useState } from "react";
import styled from "styled-components";
import { getFilterList, getParsedKeywords } from "./utils";
import type { DefaultInputFieldProps, IItem } from "@similarweb/pro-logic-components";
import { TYPE_KEYWORD, TYPE_KEYWORD_LIST } from "./consts";
import { allTrackers } from "app/services/track/track";

export const TextFieldComponentWrapper = styled.div<{ width: number }>`
    width: ${({ width }) => `${width}px`};
`;
const NAME = "name";
const trackNewRule = (newValue: IItem[], isKeywordGroup: boolean) => {
    let keyword, type;
    if (isKeywordGroup) {
        keyword = newValue[0].text;
        type = "group";
    } else {
        keyword = newValue.map((item) => item.text).join(",");
        type = "keyword";
    }
    allTrackers.dispatchTrackEvent("Drop Down", "click", `keyword added/${keyword}/${type}`);
};

export const TextFieldComponent: FC<DefaultInputFieldProps> = (props) => {
    const { rule, maxItemsPerRule, textBoxWidth, onAddNewRule } = props;
    const isDisabled = rule.items?.length >= maxItemsPerRule;

    const [isRowActive, setIsRowActive] = useState(false);

    const onAutoCompleteToggle = (isOpen) => (isOpen ? setIsRowActive(true) : setIsRowActive(false));

    const handleOnAddNewRule = (value: string | object | undefined, e) => {
        const selectedValue = value ?? e.target.innerText;
        const isKeywordGroup = !!selectedValue.Id;
        const newValue: IItem[] = isKeywordGroup
            ? [
                  {
                      type: TYPE_KEYWORD_LIST,
                      id: selectedValue?.Id,
                      text: selectedValue?.Name,
                      iconName: "keyword-group" as IconName,
                  },
              ]
            : getParsedKeywords(
                  Object.prototype.hasOwnProperty.call(selectedValue, NAME) ? selectedValue.name : selectedValue,
              );
        trackNewRule(newValue, isKeywordGroup);
        onAddNewRule(newValue);
        setIsRowActive(false);
    };

    return (
        <TextFieldComponentWrapper width={textBoxWidth}>
            <AutoCompleteKeywordGroupsSingleTab
                onSelect={handleOnAddNewRule}
                textFieldIconName="keywords"
                selectedValue=""
                autocompleteProps={{
                    placeholder: translate("multi.include.exclude.keywords.placeholder.keywords"),
                    disabled: isDisabled,
                }}
                keywordsGroupsToFilterFromAutocomplete={getFilterList(TYPE_KEYWORD_LIST, rule.items)}
                keywordsToFilterFromAutocomplete={getFilterList(TYPE_KEYWORD, rule.items)}
                className={isRowActive ? "autocomplete-open" : ""}
                onAutoCompleteToggle={onAutoCompleteToggle}
                preventTruncateUnlessForced={false}
            />
        </TextFieldComponentWrapper>
    );
};
